import React from 'react';
import { useParams } from 'react-router-dom';
import { permissionObj } from '../../../../Helpers/permission';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { toast } from 'react-toastify';
import FullPageLoader from '../../../../utils/FullPageLoader';
import SendQrBtn from '../../../../components/buttons/SendQrBtn';
import UnlinkDeviceBtn from '../../../../components/buttons/UnlinkDeviceBtn';
import DeleteModal from '../../../Modals/DeleteModal';
import PluginWarnModal from '../../../Modals/PluginWarnModal';
import BtnResetByAttemps from '../../../../components/buttons/BtnResetByAttemps';
import BtnResetByImpersonation from '../../../../components/buttons/BtnResetByImpersonation';
import GenerateVCard from './Modal/GenerateVCard';
import EmployeeApp from './Functionality/EmployeeApp';
import routes from '../../../../Routes/routes';
import HeadTittle from '../../../../components/HeadTittle';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import { EditIcon } from '../../../../components/buttons/IconButtons';
import DivContainerBody from '../../../../components/DivContainerBody';
import CopySecretModal from './Modal/CopySecretModal';
import { STATUS_MODEL } from '../../../../enums/statusEnum';
import UpdateEmployeeWithExtraData from './SubComponents/UpdateEmployeeWithExtraData';
import UpdateEmployeeWithoutExtraData from './SubComponents/UpdateEmployeeWithoutExtraData';

const UpdateEmployee = () => {
    const { id } = useParams();

    const {
        navigate,
        contractorId,
        supplierId,
        permission,
        DEV,
        t,
        employeeWorkStations,
        headersList,
        employeeRoles,
        contractStatusList,
        getUserRestriction,
        employeeDepartments,
        disabled,
        steps,
        activeStep,
        setActiveStep,
        userData,
        setUserData,
        extraData,
        setExtraData,
        employeeData,
        setEmployeeData,
        isValidEmail,
        isValidPassword,
        isValidDocumentId,
        isValidPin,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        isValidStartDate,
        setIsValidStartDate,
        isValidEndDate,
        setIsValidEndDate,
        emptyFields,
        setEmptyFields,
        selectVehicleForDelete,
        setSelectVehicleForDelete,
        isAllChecked,
        setIsAllChecked,
        cardsList,
        setCardsList,
        documentsList,
        showUnlinkBtn,
        extraDataEnabled,
        loadingProgress,
        fingerprintsList,
        updated,
        setUpdated,
        workShiftsList,
        setWorkShiftsList,
        customizedList,
        setCustomizedList,
        vehicleData,
        updatedFinger,
        setSelectedReader,
        fingerprintName,
        setFingerprintName,
        capturedFingerprint,
        setCapturedFingerprint,
        capturing,
        setCapturing,
        fingerprintSrc,
        setFingerprintSrc,
        deletePermitShow,
        setDeletePermitShow,
        vCardShow,
        setVCardShow,
        showPluginWarn,
        setShowPluginWarn,
        secretModal,
        setSecretModal,
        secretKey,
        setSecretKey,
        setModified,
        photoPickerFile,
        setPhotoPickerFile,
        handleStepChange,
        handleFormChangeUserData,
        handleUpdateEmployee,
        handleUploadFinger,
        deleteSelectedPermits,
        handleDeleteAll,
        handleCheckboxChangeVehicle,
        handleFormChangeExtraData,
        handleFormChangeEmployeeData,
        handleDeleteImage,
        isPilgrimsValidation,
        isSelfieValid,
        emptySelfie,
        setEmptySelfie,
        isValidCecoCode,
        fingerprintsTemp,
        setFingerprintsTemp,
        mergedFingerprints,
        resetForm,
    } = EmployeeApp();

    if (
        contractorId === null &&
        supplierId === null &&
        !DEV &&
        !permission?.includes(permissionObj?.WEB_EMPLOYEE_UPDATE) &&
        !permission?.includes(permissionObj?.WEB_EMPLOYEE_READ)
    )
        navigate(routes.forbidden);
    return (
        <>
            {loadingProgress && <FullPageLoader />}

            <HeadTittle link={routes.employee.list} name={disabled ? 'details' : 'update'}>
                {(DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_UPDATE)) && (
                    <ButtonAction
                        id='btn_up_update'
                        name={'update'}
                        className={'btn-icon-edit'}
                        Icon={EditIcon}
                        onClick={() => {
                            if (
                                employeeData.roleId !== '' &&
                                employeeData.employeeId !== '' &&
                                employeeData.startDate !== null &&
                                isValidStartDate &&
                                isValidEndDate &&
                                userData.isValid() &&
                                employeeData.isValid(isPilgrimsValidation) &&
                                isValidEmail &&
                                isValidPassword &&
                                isValidPhoneNumber &&
                                isValidDob &&
                                isValidDocumentId &&
                                isValidPin &&
                                (!isPilgrimsValidation || isSelfieValid) &&
                                isValidCecoCode
                            ) {
                                handleUpdateEmployee();
                                setEmptyFields(false);
                                setEmptySelfie(false);
                            } else {
                                if (isPilgrimsValidation && !isSelfieValid) {
                                  setEmptySelfie(true);
                                }
                                setEmptyFields(true);
                                toast.warn(t('please_fill_all_fields'));
                            }
                        }}
                    />
                )}

                {(DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_UPDATE)) &&
                    getUserRestriction.extraDataEmployee && (
                        <ButtonAction
                            id='btn_ae_import_data'
                            name='generate_vcode'
                            className='btn-icon-export'
                            Icon={MailOutlineIcon}
                            disabled={false}
                            splitName={false}
                            onClick={() => {
                                setVCardShow(true);
                            }}
                        />
                    )}

                {userData.statusId === STATUS_MODEL.ACCOUNT_LOCKED && <BtnResetByAttemps id={userData.id} />}
                {userData.statusId === STATUS_MODEL.IDENTITY_THEFT && <BtnResetByImpersonation id={userData.id} />}
                <SendQrBtn userId={userData.id} />
                {showUnlinkBtn && <UnlinkDeviceBtn userId={userData.id} updated={() => setUpdated(true)} />}
            </HeadTittle>

            <DivContainerBody>
                {extraDataEnabled ? (
                    <UpdateEmployeeWithExtraData
                        id={id}
                        disabled={disabled}
                        steps={steps}
                        activeStep={activeStep}
                        setActiveStep={setActiveStep}
                        handleStepChange={handleStepChange}
                        userData={userData}
                        handleFormChangeUserData={handleFormChangeUserData}
                        emptyFields={emptyFields}
                        isValidPhoneNumber={isValidPhoneNumber}
                        isValidDocumentId={isValidDocumentId}
                        isValidDob={isValidDob}
                        setIsValidDob={setIsValidDob}
                        isValidPin={isValidPin}
                        isValidEmail={isValidEmail}
                        extraData={extraData}
                        handleFormChangeExtraData={handleFormChangeExtraData}
                        setExtraData={setExtraData}
                        headersList={headersList}
                        employeeData={employeeData}
                        employeeRoles={employeeRoles}
                        employeeWorkStations={employeeWorkStations}
                        contractStatusList={contractStatusList}
                        employeeDepartments={employeeDepartments}
                        isValidStartDate={isValidStartDate}
                        setIsValidStartDate={setIsValidStartDate}
                        isValidEndDate={isValidEndDate}
                        setIsValidEndDate={setIsValidEndDate}
                        handleFormChangeEmployeeData={handleFormChangeEmployeeData}
                        setEmployeeData={setEmployeeData}
                        isPilgrimsValidation={isPilgrimsValidation}
                        permission={permission}
                        permissionObj={permissionObj}
                        photoPickerFile={photoPickerFile}
                        setPhotoPickerFile={setPhotoPickerFile}
                        emptySelfie={emptySelfie}
                        handleDeleteImage={handleDeleteImage}
                        cardsList={cardsList}
                        setCardsList={setCardsList}
                        documentsList={documentsList}
                        updated={updated}
                        setUpdated={setUpdated}
                        vehicleData={vehicleData}
                        selectVehicleForDelete={selectVehicleForDelete}
                        handleCheckboxChangeVehicle={handleCheckboxChangeVehicle}
                        isAllChecked={isAllChecked}
                        handleDeleteAll={handleDeleteAll}
                        setDeletePermitShow={setDeletePermitShow}
                        workShiftsList={workShiftsList}
                        setWorkShiftsList={setWorkShiftsList}
                        customizedList={customizedList}
                        setCustomizedList={setCustomizedList}
                        resetForm={resetForm}
                        t={t}
                        capturing={capturing}
                        setCapturing={setCapturing}
                        capturedFingerprint={capturedFingerprint}
                        setCapturedFingerprint={setCapturedFingerprint}
                        fingerprintSrc={fingerprintSrc}
                        setFingerprintSrc={setFingerprintSrc}
                        updatedFinger={updatedFinger}
                        setFingerprintName={setFingerprintName}
                        setSelectedReader={setSelectedReader}
                        fingerprintsList={fingerprintsList}
                        setModified={setModified}
                        fingerprintName={fingerprintName}
                        handleUploadFinger={handleUploadFinger}
                        setEmptyFields={setEmptyFields}
                        fingerprintsTemp={fingerprintsTemp}
                        setFingerprintsTemp={setFingerprintsTemp}
                        mergedFingerprints={mergedFingerprints}
                        DEV={DEV}
                        isValidCecoCode={isValidCecoCode}
                    />
                ) : (
                    <UpdateEmployeeWithoutExtraData
                        id={id}
                        disabled={disabled}
                        steps={steps}
                        activeStep={activeStep}
                        setActiveStep={setActiveStep}
                        handleStepChange={handleStepChange}
                        userData={userData}
                        handleFormChangeUserData={handleFormChangeUserData}
                        emptyFields={emptyFields}
                        isValidDocumentId={isValidDocumentId}
                        isValidPhoneNumber={isValidPhoneNumber}
                        isValidDob={isValidDob}
                        setIsValidDob={setIsValidDob}
                        isValidPin={isValidPin}
                        isValidEmail={isValidEmail}
                        employeeData={employeeData}
                        employeeRoles={employeeRoles}
                        employeeWorkStations={employeeWorkStations}
                        contractStatusList={contractStatusList}
                        employeeDepartments={employeeDepartments}
                        isValidStartDate={isValidStartDate}
                        setIsValidStartDate={setIsValidStartDate}
                        isValidEndDate={isValidEndDate}
                        setIsValidEndDate={setIsValidEndDate}
                        handleFormChangeEmployeeData={handleFormChangeEmployeeData}
                        setEmployeeData={setEmployeeData}
                        isPilgrimsValidation={isPilgrimsValidation}
                        permission={permission}
                        permissionObj={permissionObj}
                        photoPickerFile={photoPickerFile}
                        setPhotoPickerFile={setPhotoPickerFile}
                        emptySelfie={emptySelfie}
                        handleDeleteImage={handleDeleteImage}
                        cardsList={cardsList}
                        setCardsList={setCardsList}
                        documentsList={documentsList}
                        updated={updated}
                        setUpdated={setUpdated}
                        vehicleData={vehicleData}
                        selectVehicleForDelete={selectVehicleForDelete}
                        handleCheckboxChangeVehicle={handleCheckboxChangeVehicle}
                        isAllChecked={isAllChecked}
                        handleDeleteAll={handleDeleteAll}
                        setDeletePermitShow={setDeletePermitShow}
                        workShiftsList={workShiftsList}
                        setWorkShiftsList={setWorkShiftsList}
                        customizedList={customizedList}
                        setCustomizedList={setCustomizedList}
                        resetForm={resetForm}
                        t={t}
                        capturing={capturing}
                        setCapturing={setCapturing}
                        capturedFingerprint={capturedFingerprint}
                        setCapturedFingerprint={setCapturedFingerprint}
                        fingerprintSrc={fingerprintSrc}
                        setFingerprintSrc={setFingerprintSrc}
                        updatedFinger={updatedFinger}
                        setFingerprintName={setFingerprintName}
                        setSelectedReader={setSelectedReader}
                        fingerprintsList={fingerprintsList}
                        setModified={setModified}
                        fingerprintName={fingerprintName}
                        handleUploadFinger={handleUploadFinger}
                        setEmptyFields={setEmptyFields}
                        fingerprintsTemp={fingerprintsTemp}
                        setFingerprintsTemp={setFingerprintsTemp}
                        mergedFingerprints={mergedFingerprints}
                        DEV={DEV}
                        isValidCecoCode={isValidCecoCode}
                    />
                )}
            </DivContainerBody>

            <DeleteModal
                show={deletePermitShow}
                onHide={() => setDeletePermitShow(false)}
                onClickFn={() => deleteSelectedPermits()}
                data={selectVehicleForDelete}
                isReset={setSelectVehicleForDelete}
                isAllReset={setIsAllChecked}
                title_modal={t('delete_permits')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('permits')}
            />
            <GenerateVCard show={vCardShow} onHide={() => setVCardShow(false)} />
            <PluginWarnModal show={showPluginWarn} onHide={() => setShowPluginWarn(false)} />
            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUserData}
                onHide={() => {}}
                closeText={'close'}
            />
        </>
    );
};

export default UpdateEmployee;
